import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

// 字體大小選項配置
// 基於目前的 14px 作為「小」，中為小的115%，大為中的115%
// 「大」字體選項同時設定為粗體
const FONT_SIZE_OPTIONS = [
  { label: '小', value: 'small', size: '14px', scale: 1, fontWeight: 'normal' },
  { label: '中', value: 'medium', size: '16px', scale: 1.15, fontWeight: 'normal' },
  { label: '大', value: 'large', size: '18px', scale: 1.32, fontWeight: 'bold' }
]

// localStorage 鍵名
const FONT_SETTINGS_KEY = 'admin_font_settings'

export const useFontSettingsStore = defineStore('fontSettings', () => {
  // 從 localStorage 初始化字體設定，預設為小字體（原本的大小）
  const savedSettings = JSON.parse(localStorage.getItem(FONT_SETTINGS_KEY) || '{}')

  // 當前字體大小設定
  const currentFontSize = ref(savedSettings.fontSize || 'small')
  
  // 獲取當前字體大小配置
  const getCurrentFontConfig = () => {
    return FONT_SIZE_OPTIONS.find(option => option.value === currentFontSize.value) || FONT_SIZE_OPTIONS[0]
  }
  
  // 設定字體大小
  const setFontSize = (size) => {
    if (FONT_SIZE_OPTIONS.some(option => option.value === size)) {
      currentFontSize.value = size
      applyFontSize()
    }
  }
  
  // 應用字體大小到頁面
  const applyFontSize = () => {
    const config = getCurrentFontConfig()
    const root = document.documentElement

    // 設定 CSS 自定義屬性
    root.style.setProperty('--admin-font-size', config.size)
    root.style.setProperty('--admin-font-scale', config.scale)
    root.style.setProperty('--admin-font-weight', config.fontWeight)

    // 設定 body 的基礎字體大小和字體粗細
    document.body.style.fontSize = config.size
    document.body.style.fontWeight = config.fontWeight
  }
  
  // 獲取所有字體大小選項
  const getFontSizeOptions = () => {
    return FONT_SIZE_OPTIONS
  }
  
  // 監聽字體大小變化，持久化到 localStorage
  watch(currentFontSize, (newSize) => {
    const settings = {
      fontSize: newSize,
      updatedAt: new Date().toISOString()
    }
    localStorage.setItem(FONT_SETTINGS_KEY, JSON.stringify(settings))
  }, { immediate: false })
  
  // 初始化字體設定
  const initializeFontSettings = () => {
    applyFontSize()
  }
  
  return {
    currentFontSize,
    getCurrentFontConfig,
    setFontSize,
    applyFontSize,
    getFontSizeOptions,
    initializeFontSettings
  }
})
